import { gql } from "urql";
export const GetInsuranceCountQuery = gql `
    query GetInsuranceCount($search: String) {
        insurances {
            insuranceCount(search: $search)
        }
    }
`;
export const GetInsurancesQuery = gql `
    query GetInsurances($search: String, $offset: Int) {
        insurances {
            insurances(search: $search, offset: $offset) {
                insuranceId
                name
                isActive
            }
        }
    }
`;
